import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import { useUpsellProducts } from '@/composables/attraqt/useAttraqtIntegration';
import { useCart } from '~/composables/useCart';
import useRightPath from '~/composables/useRightPath';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { createObjectFromNumbers } from '~/utils/CreateObjectFromNumbers';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'UpSellProduct',
  props: {
    product: {
      type: Object,
      required: true
    },
    widgetId: {
      type: String,
      required: true
    },
    recommendationId: {
      type: String,
      required: true
    },
    index: {
      type: Number
    },
    showPrice: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var _useCart = useCart(),
      cart = _useCart.cart,
      addItem = _useCart.addItem;
    var route = useRoute();
    var router = useRouter();
    var product = computed(function () {
      return props.product.product;
    });
    var taxRate = computed(function () {
      var _cart$value, _cart$value$taxedPric, _cart$value$taxedPric2, _cart$value$taxedPric3;
      return (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : (_cart$value$taxedPric = _cart$value.taxedPrice) === null || _cart$value$taxedPric === void 0 ? void 0 : (_cart$value$taxedPric2 = _cart$value$taxedPric.taxPortions) === null || _cart$value$taxedPric2 === void 0 ? void 0 : (_cart$value$taxedPric3 = _cart$value$taxedPric2[0]) === null || _cart$value$taxedPric3 === void 0 ? void 0 : _cart$value$taxedPric3.rate;
    });
    var priceInCents = computed(function () {
      return Number(product.value.price.toFixed(2));
    });
    var priceInEuro = computed(function () {
      return Number((product.value.price / 100).toFixed(2));
    });
    var upsellProducts = useUpsellProducts();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency;
    var onAddToCart = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _product$value, _product$value$_id, _product$value2, _product$value2$_id, _product$value3, _product$value3$_id, _product$value4, _product$value4$_id, _product$value5, _product$value5$_id, _product$value6, _cart$value2, _product$value7;
        var productData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              productData = {
                sku: (_product$value = product.value) === null || _product$value === void 0 ? void 0 : (_product$value$_id = _product$value._id) === null || _product$value$_id === void 0 ? void 0 : _product$value$_id.original_id,
                name: product.value.title
              };
              _context.next = 3;
              return addItem({
                product: {
                  sku: props.product.id
                },
                quantity: 1
              });
            case 3:
              upsellProducts.sendUpsellClick(productData, props.recommendationId, props.widgetId, props.index + 1);
              trackDynamicYieldEvent({
                name: 'Add to Cart',
                properties: {
                  dyType: 'add-to-cart-v1',
                  value: formatDYprice(priceInEuro.value),
                  currency: 'EUR',
                  productId: (_product$value2 = product.value) === null || _product$value2 === void 0 ? void 0 : (_product$value2$_id = _product$value2._id) === null || _product$value2$_id === void 0 ? void 0 : _product$value2$_id.original_id,
                  quantity: 1,
                  cart: [{
                    productId: (_product$value3 = product.value) === null || _product$value3 === void 0 ? void 0 : (_product$value3$_id = _product$value3._id) === null || _product$value3$_id === void 0 ? void 0 : _product$value3$_id.original_id,
                    quantity: 1,
                    itemPrice: formatDYprice(priceInEuro.value)
                  }]
                }
              });
              $trackers.gtm.trackAddToCart({
                title: product.value.title,
                sku: (_product$value4 = product.value) === null || _product$value4 === void 0 ? void 0 : (_product$value4$_id = _product$value4._id) === null || _product$value4$_id === void 0 ? void 0 : _product$value4$_id.original_id,
                originalId: (_product$value5 = product.value) === null || _product$value5 === void 0 ? void 0 : (_product$value5$_id = _product$value5._id) === null || _product$value5$_id === void 0 ? void 0 : _product$value5$_id.original_id,
                priceRegular: priceInEuro.value,
                quantity: 1,
                itemLocation: 'upsell_product',
                currency: currency,
                isMaster: (_product$value6 = product.value) === null || _product$value6 === void 0 ? void 0 : _product$value6._master,
                pageUrl: route.fullPath,
                sourceId: props.widgetId,
                cartId: ((_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : _cart$value2.id) || '',
                ctId: (_product$value7 = product.value) === null || _product$value7 === void 0 ? void 0 : _product$value7._id
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onAddToCart() {
        return _ref.apply(this, arguments);
      };
    }();
    var isGlobalPrice = function isGlobalPrice(taxRate) {
      return taxRate === 0;
    };
    var isDiscounted = function isDiscounted(taxRate) {
      return getFullPrice(taxRate) - getDiscountedPrice(taxRate) !== 0;
    };
    var getFullPrice = function getFullPrice(taxRate) {
      if (isGlobalPrice(taxRate)) {
        return product.value.displayVariantPriceGlobalFull || product.value.displayVariantPriceGlobal;
      } else {
        return product.value.displayVariantPriceEUFull || product.value.displayVariantPriceEU;
      }
    };
    var getDiscountedPrice = function getDiscountedPrice(taxRate) {
      if (isGlobalPrice(taxRate)) {
        return product.value.displayVariantPriceGlobal;
      } else {
        return product.value.displayVariantPriceEU;
      }
    };
    var productPageLink = function productPageLink() {
      var _product$value8;
      return app.localePath(getProductPath({
        slug: (_product$value8 = product.value) === null || _product$value8 === void 0 ? void 0 : _product$value8.url
      }));
    };
    var handleRedirect = function handleRedirect() {
      toggleCartSidebar();
      router.push(productPageLink());
    };
    return {
      __sfc: true,
      props: props,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      formatDYprice: formatDYprice,
      cart: cart,
      addItem: addItem,
      route: route,
      router: router,
      product: product,
      taxRate: taxRate,
      priceInCents: priceInCents,
      priceInEuro: priceInEuro,
      upsellProducts: upsellProducts,
      app: app,
      $trackers: $trackers,
      getProductPath: getProductPath,
      toggleCartSidebar: toggleCartSidebar,
      currency: currency,
      onAddToCart: onAddToCart,
      isGlobalPrice: isGlobalPrice,
      isDiscounted: isDiscounted,
      getFullPrice: getFullPrice,
      getDiscountedPrice: getDiscountedPrice,
      productPageLink: productPageLink,
      handleRedirect: handleRedirect,
      PriceDisplay: PriceDisplay,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom,
      createObjectFromNumbers: createObjectFromNumbers
    };
  }
});